import FinancialLogsModule from './FinancialLogsModule';

export default FinancialLogsModule;